import { ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface EmptyStateProps {
  title?: string
  description?: string
  icon?: ReactNode
  className?: string
  children?: ReactNode
}

const EmptyState = ({ title, description, icon, className, children }: EmptyStateProps) => {
  return (
    <div className={cn('py-12 text-center', className)}>
      {icon && <div className="mb-4">{icon}</div>}
      {title && <h3 className="mb-2 text-lg font-semibold">{title}</h3>}
      {description && <p className="text-muted-foreground">{description}</p>}
      {children}
    </div>
  )
}

export default EmptyState
